import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {DataService} from '../../data/data.ts';
import { ToastController } from 'ionic-angular';
import * as firebase from 'firebase';

@Component({
  templateUrl: 'build/pages/wallet/wallet.html'
})
export class WalletPage {
  private dataService: DataService;
  public transferRecipient: string;
  public transferAmount: number;
  public fakeTransferAmount: number;
  public callback : Function;

  constructor(private navCtrl: NavController, private toastController : ToastController, private _data: DataService) {
  	this.dataService = _data;
  	this.transferRecipient = null;
    this.transferAmount = 0;
    this.fakeTransferAmount = 0;
    this.callback = (error) => {
      if (error) {
        this.createToastWithMessage("Funds failed to transfer :( Try again.");
      } else {
        this.createToastWithMessage("Funds were transferred succesfully!");
      }
    }
  }

  ionViewLoaded() {
  }

  characterKeys() : Array<string> {
    return Object.keys(this.dataService.allCharacters);
  }

  fakeTransferMoney(){
    if (this.fakeTransferAmount <= 0){
      this.createToastWithMessage("You must enter a value > 0!");
    }else if(this.fakeTransferAmount > this.dataService.availableFunds){
      this.createToastWithMessage("Insufficient funds.");
    }else{
      this.dataService.availableFunds = this.dataService.availableFunds - this.fakeTransferAmount;
      this.createToastWithMessage("Your funds were transferred!");
    }
  }

  transferMoney(){
    if (this.transferAmount <= 0){
      this.createToastWithMessage("must enter value > 0!");
    }else if(this.transferAmount > this.dataService.availableFunds){
      this.createToastWithMessage("insufficient funds.");
    }else if(this.transferRecipient == undefined || this.transferRecipient == null){
      this.createToastWithMessage("no recipient selected");
    }else{
      this.dataService.transferFunds(this.transferAmount, this.transferRecipient,this.callback);
    }
  }

  createToastWithMessage(message){
    let toast = this.toastController.create({
      message: message,
      duration: 3000,
      position: 'middle'
    });
    toast.present();
  }
}
